// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sales-report-container-odpYi {
  display: flex;
  align-items: center;
  gap: 32px;
}

.sales-report-item-pInCB {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.sales-report-title-CAPqv {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.75);
}

.sales-report-amount-AEFVt {
  color: var(--money-color);
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/sales-report/sales-report.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n}\n\n.item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n}\n\n.title {\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.amount {\n  color: var(--money-color);\n  font-size: 14px;\n  font-weight: bold;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `sales-report-container-odpYi`,
	"item": `sales-report-item-pInCB`,
	"title": `sales-report-title-CAPqv`,
	"amount": `sales-report-amount-AEFVt`
};
export default ___CSS_LOADER_EXPORT___;
